import React from 'react';
import Step1 from "./WizardSteps/step1";
import Step2 from "./WizardSteps/step2";
import Step3 from "./WizardSteps/step3";
import Step4 from "./WizardSteps/step4";
import Step5 from "./WizardSteps/step5";
import Step6 from "./WizardSteps/step6";
import '../../style/dots.css';
import Dots from 'react-activity/lib/Dots';
import Button from "../button";
import ProgressBarItem from "./WizardSteps/progressBarItem";
import GeneralSVG from "../generalSVG";
import FormGroupPlainText from "../formGroupPlainText";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';
import { Link } from 'arag-ui-lib';
import {clearSuccessMsg} from "../../helpers/utilMessage";
import { PS_TYPE_PERCENTAGE } from '../../helpers/constants';
import { useLocation } from 'react-router-dom';
import PercentageStep4 from './WizardSteps/percentageStep4';
import PercentageStep6 from './WizardSteps/percentageStep6';

const PremiumSettingsWizard = (props) => {

	const location = useLocation();

	if(props.premiumSettingsWizard.failedToFetchMessage){
		return (
			<div className={'col-sm-12'}>
				<FormResponseMessage
					LeftWrapper=""
					CenterWrapper="col-sm-12"
					MessageStyle="formResponseMessage-reject"
					Message={props.premiumSettingsWizard.failedToFetchMessage}
				/>
			</div>
		)
	}

    if (props.premiumSettingsWizard.fetchingStepMessages || props.fetchingDamages || props.fetchingStages || props.fetchingCaseTypes
        || (props.premiumSettingsWizard.tableData.length > 0 && props.premiumSettingsWizard.damageBands.length === 0 && props.showTable) 
		|| (props.premiumSettingsWizard.fetchingExistingPremium)
    ) {
        return (
			<div className="col-sm-12">
				<div className="col-sm-5"></div>
				<div className="col-sm-6">
					<div className="col-sm-1"></div>
					<Dots/>
				</div>
			</div>
        )
    }

    if(props.showTable){
        return(
			<div>
                {props.isApplicationPremium && (
                    <h3>Application Premium Settings</h3>
                )}
                <form className="form-horizontal premiumSettingsWizard-formWrapper" >
					{props.premiumSettingTypePercentage  ?
						<PercentageStep6
							tableHeaderData = {props.tableHeaderData}
							solicitorListLength={props.premiumSettingsWizard.solicitorListLength}
							showTable={props.showTable}
							selectedCaseType={props.selectedCaseType}
							selectedSubCaseType={props.selectedSubCaseType}
							getSolicitor={props.getSolicitor}
							successMsg={props.premiumSettingsWizard.successMsg}
							badResponseMsg={props.premiumSettingsWizard.badResponseMsg}
							posting={props.premiumSettingsWizard.posting}
							tableData={props.premiumSettingsWizard.tableData}
							damageBands={props.premiumSettingsWizard.damageBands}
							selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
							solicitorsList={props.premiumSettingsWizard.solicitorsList}
							getTableHeaderData={props.getTableHeaderData}
							limitOfIndemnity={props.premiumSettingsWizard.limitOfIndemnity}
							recoverableRatePercentage={props.premiumSettingsWizard.recoverableRatePercentage}
							validFrom={props.premiumSettingsWizard.validFrom}
							validUntil={props.premiumSettingsWizard.validUntil}
							notes={props.premiumSettingsWizard.notes}
							endorsements={props.premiumSettingsWizard.endorsements}
							comments={props.premiumSettingsWizard.comments}
							changeWizardStep={props.changeWizardStep}
							currentStep={6}
							displayedCoverageType={props.displayedCoverageType}
							displayedDeductible={props.displayedDeductible}
							displayedEndorsement={props.displayedEndorsement}						
							isApplicationPremium={props.isApplicationPremium}
						/> :
						<Step6
							tableHeaderData = {props.tableHeaderData}
							solicitorListLength={props.premiumSettingsWizard.solicitorListLength}
							showTable={props.showTable}
							selectedCaseType={props.selectedCaseType}
							selectedSubCaseType={props.selectedSubCaseType}
							getSolicitor={props.getSolicitor}
							successMsg={props.premiumSettingsWizard.successMsg}
							badResponseMsg={props.premiumSettingsWizard.badResponseMsg}
							posting={props.premiumSettingsWizard.posting}
							tableData={props.premiumSettingsWizard.tableData}
							damageBands={props.premiumSettingsWizard.damageBands}
							selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
							solicitorsList={props.premiumSettingsWizard.solicitorsList}
							getTableHeaderData={props.getTableHeaderData}
							limitOfIndemnity={props.premiumSettingsWizard.limitOfIndemnity}
							validFrom={props.premiumSettingsWizard.validFrom}
							validUntil={props.premiumSettingsWizard.validUntil}
							notes={props.premiumSettingsWizard.notes}
							endorsements={props.premiumSettingsWizard.endorsements}
							comments={props.premiumSettingsWizard.comments}
							changeWizardStep={props.changeWizardStep}
							currentStep={6}
							displayedCoverageType={props.displayedCoverageType}
							displayedDeductible={props.displayedDeductible}
							displayedEndorsement={props.displayedEndorsement}						
							isApplicationPremium={props.isApplicationPremium}
							isPercentagePremium={props.premiumSettingsWizard.isPercentagePremium}
							recoverableRatePercentage={props.premiumSettingsWizard.recoverableRatePercentage}
						/>
					}
                    {(props.premiumSettingsWizard.patching || props.appPremiumSettingsIndicator) && (
                        <div className={'col-sm-12'}><CenteredDots/></div>
                    )}
                    {(props.isApplicationPremium) && (
                        <div>
                            {props.isChangingStatusOfApp && (
                                <Button
                                    btnType={'button'}
                                    wrapper="btn-wrapper"
                                    clickHandler={props.handleSubmitStep6}
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label={'Save and go live'}
                                />
                            )}
                            <Button
                                btnType={'button'}
                                wrapper="btn-wrapper"
                                clickHandler={props.onApplicationPremiumEdit}
                                btnStyle={'btn btn-primary btn-xs sharp white'}
                                label={'Edit'}
                            />
							 {props.isChangingStatusOfApp && (<Link
                                    variant='tertiary'
                                    label={"Cancel"}
                                    arrowDirection='left'
                                    onClick={props.onCancelAppPremiumSettings}
                                /> )}
                        </div>
                    )}
                </form>
            </div>
        )
    }

    return (
		<div className="row">
			<div className="col-sm-12">
				<h2 className="solicitor-form-title">
                    {
                        props.premiumSettingsWizard.isEditMode?
							<span>Edit Premium Setting</span>
                            :
							<span>New Premium Setting</span>
                    }
				</h2>
				<form className="form-horizontal">
                    {
                        props.selectedSolicitorGroupName?
							<FormGroupPlainText
								LeftWrapper="col-sm-3"
								Label={`${LEGAL_ADVICE_TEXT} group`}
								InputWrapper="manageSolicitorAccount-data col-sm-6"
								Text={props.selectedSolicitorGroupName}
							/>
                            :
                            null
                    }
                    {
                        props.selectedWorksourceName?
							<FormGroupPlainText
								LeftWrapper="col-sm-3"
								Label="Work source"
								InputWrapper="manageSolicitorAccount-data col-sm-6"
								Text={props.selectedWorksourceName}
							/>
                            :
                            null
                    }
                    {
                        props.selectedCaseType?
							<FormGroupPlainText
								LeftWrapper="col-sm-3"
								Label="Case type"
								InputWrapper="manageSolicitorAccount-data col-sm-6"
								Text={props.selectedCaseType}
							/>
                            :
                            null
                    }
                    {
                        props.selectedSubCaseTypeName?
							<FormGroupPlainText
								LeftWrapper="col-sm-3"
								Label="Selected sub case type"
								InputWrapper="manageSolicitorAccount-data col-sm-6"
								Text={props.selectedSubCaseTypeName}
							/>
                            :
                            null
                    }
				</form>

				<div className="row">
					<div className="col-sm-12">
						<hr className="appFormRefSettings-hr"/>
					</div>
				</div>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[0].name}
					stepNumber={props.steps[0].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[1].name}
					stepNumber={props.steps[1].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[2].name}
					stepNumber={props.steps[2].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[3].name}
					stepNumber={props.steps[3].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[4].name}
					stepNumber={props.steps[4].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
				<ProgressBarItem
					isEditMode={props.premiumSettingsWizard.isEditMode}
					changeStepThroughProgressBar={props.changeStepThroughProgressBar}
					label={props.steps[5].name}
					stepNumber={props.steps[5].stepNumber}
					currentStep={props.premiumSettingsWizard.currentStep}/>
                {
                    props.premiumSettingsWizard.currentStep > 1 ?
						<div className="row">
							<div className="col-sm-12">
								<div onClick={() => props.changeWizardStep('decrease')}>
									<GeneralSVG
										SvgWrapper="premiumSettingsWizard-previousStep-wrapper inlineBlock"
										Label={'Back to ' + props.steps[props.premiumSettingsWizard.currentStep - 2].name}
										Svg={<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 9.6 16"><title>
											Asset
											2</title>
											<g id="Layer_2"
											   data-name="Layer 2">
												<g id="Layer_1-2"
												   data-name="Layer 1">
													<path
														d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
												</g>
											</g>
										</svg>}
									/>
								</div>
							</div>
						</div>
                        :
                        null
                }
				<form className="form-horizontal premiumSettingsWizard-formWrapper" onSubmit={props.handleSubmit}>
					<div>
						<Step1
							stepMessage={props.getStepMessage('1')}
							caseStages={props.caseStages}
							handleCaseStagesSelectMultipleChange={props.handleCaseStagesSelectMultipleChange}
							handleCaseStagesCheckedState={props.handleCaseStagesCheckedState}
							changeWizardStep={props.changeWizardStep}
							currentStep={props.premiumSettingsWizard.currentStep}
						/>
						<Step2
							stepMessage={props.getStepMessage('2')}
							startOfDamageBand={props.premiumSettingsWizard.startOfDamageBand}
							endOfDamageBand={props.premiumSettingsWizard.endOfDamageBand}
							getEndDamageBands={props.getEndDamageBands}
							getStartDamageBands={props.getStartDamageBands}
							setDamageBand={props.setDamageBand}
							removeDamageBand={props.removeDamageBand}
							getDamageBandName={props.getDamageBandName}
							damageBands={props.premiumSettingsWizard.damageBands}
							getDamagesNotInDamageBands={props.getDamagesNotInDamageBands}
							addNewDamageBand={props.addNewDamageBand}
							changeStoreSettings={props.changeStoreSettings}
							openDamageBandModal={props.premiumSettingsWizard.openDamageBandModal}
							damages={props.damages}
							handleDamagesSelectMultipleChange={props.handleDamagesSelectMultipleChange}
							handleDamagesCheckedState={props.handleDamagesCheckedState}
							changeWizardStep={props.changeWizardStep}
							currentStep={props.premiumSettingsWizard.currentStep}
						/>
						<Step3
							stepMessage={props.getStepMessage('3')}
							step3WarningMsg={props.premiumSettingsWizard.step3WarningMsg}
							solicitorsList={props.premiumSettingsWizard.solicitorsList}
							removeSolicitor={props.removeSolicitor}
							addSolicitor={props.addSolicitor}
							lawsysFirms={props.lawsysFirms}
							openSolicitorModal={props.premiumSettingsWizard.openSolicitorModal}
							changeStoreSettings={props.changeStoreSettings}
							changeLawsysFirmState={props.changeLawsysFirmState}
							changeWizardStep={props.changeWizardStep}
							currentStep={props.premiumSettingsWizard.currentStep}
							onSuggestionSelected={props.onSuggestionSelected}
                			onSuggestionChange={props.onSuggestionChange}
						/>
						{
							(props.premiumSettingTypePercentage || props.premiumSettingsWizard.isPercentagePremium) ?
							<PercentageStep4
								isEditMode={props.premiumSettingsWizard.isEditMode}
								stepMessage={props.getStepMessage('4')}
								handlePercentagePremiumTableChange={props.handlePercentagePremiumTableChange}
								selectedCaseType={props.selectedCaseType}
								selectedSubCaseType={props.selectedSubCaseType}
								recoverableRatePercentage={props.premiumSettingsWizard.recoverableRatePercentage}
								changeStoreSettings={props.changeStoreSettings}
								validationMessage={props.premiumSettingsWizard.validationMessage}
								getSolicitor={props.getSolicitor}
								tableData={props.premiumSettingsWizard.tableData}
								getAgentIndex={props.getAgentIndex}
								getTableIndex={props.getTableIndex}
								handlePremiumAndUnderwriterChange={props.handlePremiumAndUnderwriterChange}
								damageBands={props.premiumSettingsWizard.damageBands}
								selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
								solicitorsList={props.premiumSettingsWizard.solicitorsList}
								getTableHeaderData={props.getTableHeaderData}
								changeWizardStep={props.changeWizardStep}
								currentStep={props.premiumSettingsWizard.currentStep}
							/>
							 :
							<Step4
								isEditMode={props.premiumSettingsWizard.isEditMode}
								stepMessage={props.getStepMessage('4')}
								handleRecoverableAndNonRecoverableChange={props.handleRecoverableAndNonRecoverableChange}
								selectedCaseType={props.selectedCaseType}
								selectedSubCaseType={props.selectedSubCaseType}
								validationMessage={props.premiumSettingsWizard.validationMessage}
								getSolicitor={props.getSolicitor}
								tableData={props.premiumSettingsWizard.tableData}
								getAgentIndex={props.getAgentIndex}
								getTableIndex={props.getTableIndex}
								handleCommissionChange={props.handleCommissionChange}
								handlePremiumAndUnderwriterChange={props.handlePremiumAndUnderwriterChange}
								damageBands={props.premiumSettingsWizard.damageBands}
								selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
								solicitorsList={props.premiumSettingsWizard.solicitorsList}
								getTableHeaderData={props.getTableHeaderData}
								changeWizardStep={props.changeWizardStep}
								currentStep={props.premiumSettingsWizard.currentStep}
							/>
						}
						<Step5
							isApplicationPremium={props.isApplicationPremium}
							premiumSettingTypeCustom={props.premiumSettingTypeCustom}
							premiumSettingTypePercentage={props.premiumSettingTypePercentage}						
							validationMessageStep5={props.premiumSettingsWizard.validationMessageStep5}
							handleDateChange={props.handleDateChange}
							stepMessage={props.getStepMessage('5')}
							limitOfIndemnity={props.premiumSettingsWizard.limitOfIndemnity}
							validFrom={props.premiumSettingsWizard.validFrom}
							validUntil={props.premiumSettingsWizard.validUntil}
							changeStoreSettings={props.changeStoreSettings}
							changeWizardStep={props.changeWizardStep}
							currentStep={props.premiumSettingsWizard.currentStep}
							notes={props.premiumSettingsWizard.notes}
							endorsements={props.premiumSettingsWizard.endorsements}
							comments={props.premiumSettingsWizard.comments}
							selectedCoverageType={props.selectedCoverageType}
							selectedDeductible={props.selectedDeductible}
							selectedEndorsement={props.selectedEndorsement}
							coveragesOptions={props.coveragesOptions}
							deductiblesOptions={props.deductiblesOptions}
							endorsementsOptions={props.endorsementsOptions}
						/>
						{
							(props.premiumSettingTypePercentage || props.premiumSettingsWizard.isPercentagePremium) ?
							<PercentageStep6
								isApplicationPremium={props.isApplicationPremium}
								appPremiumSettingsIndicator={props.appPremiumSettingsIndicator}
								isEditMode={props.premiumSettingsWizard.isEditMode}
								stepMessage={props.getStepMessage('6')}
								selectedCaseType={props.selectedCaseType}
								selectedSubCaseType={props.selectedSubCaseType}
								getSolicitor={props.getSolicitor}
								successMsg={props.premiumSettingsWizard.successMsg}
								badResponseMsg={props.premiumSettingsWizard.badResponseMsg}
								posting={props.premiumSettingsWizard.posting}
								patching={props.premiumSettingsWizard.patching}
								tableData={props.premiumSettingsWizard.tableData}
								damageBands={props.premiumSettingsWizard.damageBands}
								selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
								solicitorsList={props.premiumSettingsWizard.solicitorsList}
								getTableHeaderData={props.getTableHeaderData}
								limitOfIndemnity={props.premiumSettingsWizard.limitOfIndemnity}
								recoverableRatePercentage={props.premiumSettingsWizard.recoverableRatePercentage}
								validFrom={props.premiumSettingsWizard.validFrom}
								validUntil={props.premiumSettingsWizard.validUntil}
								notes={props.premiumSettingsWizard.notes}
								endorsements={props.premiumSettingsWizard.endorsements}
								comments={props.premiumSettingsWizard.comments}
								changeWizardStep={props.changeWizardStep}
								currentStep={props.premiumSettingsWizard.currentStep}
								displayedCoverageType={props.displayedCoverageType}
								displayedDeductible={props.displayedDeductible}
								displayedEndorsement={props.displayedEndorsement}							
						/> :
						<Step6
							isApplicationPremium={props.isApplicationPremium}
							appPremiumSettingsIndicator={props.appPremiumSettingsIndicator}
							isEditMode={props.premiumSettingsWizard.isEditMode}
							stepMessage={props.getStepMessage('6')}
							selectedCaseType={props.selectedCaseType}
							selectedSubCaseType={props.selectedSubCaseType}
							getSolicitor={props.getSolicitor}
							successMsg={props.premiumSettingsWizard.successMsg}
							badResponseMsg={props.premiumSettingsWizard.badResponseMsg}
							posting={props.premiumSettingsWizard.posting}
							patching={props.premiumSettingsWizard.patching}
							tableData={props.premiumSettingsWizard.tableData}
							damageBands={props.premiumSettingsWizard.damageBands}
							selectedCaseStages={props.premiumSettingsWizard.selectedCaseStages}
							solicitorsList={props.premiumSettingsWizard.solicitorsList}
							getTableHeaderData={props.getTableHeaderData}
							limitOfIndemnity={props.premiumSettingsWizard.limitOfIndemnity}
							validFrom={props.premiumSettingsWizard.validFrom}
							validUntil={props.premiumSettingsWizard.validUntil}
							notes={props.premiumSettingsWizard.notes}
							endorsements={props.premiumSettingsWizard.endorsements}
							comments={props.premiumSettingsWizard.comments}
							changeWizardStep={props.changeWizardStep}
							currentStep={props.premiumSettingsWizard.currentStep}
							displayedCoverageType={props.displayedCoverageType}
							displayedDeductible={props.displayedDeductible}
							displayedEndorsement={props.displayedEndorsement}							
						/>}
					</div>
					<div className="row">
						<div className="col-sm-12">
                            {
                                props.premiumSettingsWizard.currentStep <= 6?
									<div>
										<Button
											wrapper="btn-wrapper"
											btnType="submit"
											btnStyle={'btn btn-primary btn-xs sharp yellow'}
											label={props.premiumSettingsWizard.currentStep === 6 ?
												(props.premiumSettingsWizard.isEditMode?
													props.applicationPremiumSaveButtonLabel?
														props.applicationPremiumSaveButtonLabel
														:
														'Update Premium Setting'
													:
													'Create Premium Setting')
												:
												'Next Step'
											}
										/>
										<Button
											clickHandler={() => {
												props.isApplicationPremium?
													props.applicationPremiumCancelHandler()
														:
													props.goBack()													
													clearSuccessMsg(location);
											}}
											wrapper="btn-wrapper"
											btnType="button"
											btnStyle={'btn btn-primary btn-xs sharp white'}
											label={'Cancel' }
										/>
									</div>
                                    :
                                    null
                            }
						</div>
					</div>
                    {
                        props.premiumSettingsWizard.currentStep > 1 ?
							<div className="row">
								<div className="col-sm-12">
									<div onClick={() => props.changeWizardStep('decrease')}>
										<GeneralSVG
											SvgWrapper="premiumSettingsWizard-previousStep-wrapper inlineBlock"
											Label={'Back to ' + props.steps[props.premiumSettingsWizard.currentStep - 2].name}
											Svg={<svg
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 9.6 16"><title>
												Asset
												2</title>
												<g id="Layer_2"
												   data-name="Layer 2">
													<g id="Layer_1-2"
													   data-name="Layer 1">
														<path
															d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
													</g>
												</g>
											</svg>}
										/>
									</div>
								</div>
							</div>
                            :
                            null
                    }
				</form>
			</div>
		</div>
    )
};

export default PremiumSettingsWizard;